import { Actions } from './actions';
import css from './docs.module.scss';
import { Links } from './links';

export function Docs() {
    return (
        <div className={css.wrapper}>
            <Actions />
            <Links />
        </div>
    );
}
